export default "__VITE_ASSET__c7964ca5__"